var map = {
	"./arunjoshy.webp": 39311,
	"./baskar.webp": 45180,
	"./chitradevi.webp": 99681,
	"./deepika.webp": 52325,
	"./dhivyabharathi.webp": 18646,
	"./jonyblessingmanoj.webp": 55728,
	"./kavinya.webp": 90759,
	"./kavitha.webp": 96380,
	"./mohanapriya.webp": 84237,
	"./raghu.webp": 18785,
	"./ramya.webp": 12530,
	"./sangeetha.webp": 13236,
	"./senthilkumar.webp": 25277,
	"./shivaswamy.webp": 36554,
	"./srimohanapriya.webp": 5421,
	"./sudha.webp": 23283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26262;